<nav class="navbar navbar-expand-lg navbar-dark fixed-top d-print-none">
    <a class="navbar-brand py-1 ms-2" routerLink="/">
        <img src="/assets/macsafe_logo_inverted.svg" class="ms-3 p-1" alt="MacSafe" [class.d-block]="router.url.includes('/macsafe')" />
        <img src="/assets/macyouth_logo_inverted.svg" class="p-1 macyouth" alt="MacYouth" [class.d-block]="router.url.includes('/macyouth')" />
        <img
            src="/assets/macdonnell_logo_inverted.svg"
            class="mt-1"
            alt="MacDonnell Council"
            [class.d-block]="!router.url.includes('/macyouth') && !router.url.includes('/macsafe')"
        />
    </a>

    @if (userService.watch | async; as _user) {
        @if (_user.loggedIn) {
            <div class="ms-auto" display="dynamic" placement="bottom-end" ngbDropdown>
                <button class="btn profile-button" ngbDropdownToggle (click)="update()">
                    <ngxh6-usericon [user]="_user.account.user" [showTooltip]="false" class="me-0"></ngxh6-usericon>
                </button>
                <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
                    @if (userService.isGranted('ROLE_MACYOUTH') && userService.isGranted('ROLE_MACSAFE')) {
                        <h6 class="dropdown-header">Departments</h6>
                        @if (userService.isGranted('ROLE_MACYOUTH')) {
                            <button class="dropdown-item" routerLink="macyouth">MacYouth</button>
                        }
                        @if (userService.isGranted('ROLE_MACSAFE')) {
                            <button class="dropdown-item" routerLink="macsafe">MacSafe</button>
                        }
                        <button class="dropdown-item" routerLink="user-admin">My Mac Council</button>
                        <div class="dropdown-divider"></div>
                    }
                    <h6 class="dropdown-header">{{ _user.account.user?.name }}</h6>
                    <button class="dropdown-item" routerLink="user-admin"><i class="fa fa-fw fa-user me-2"></i> My Profile</button>
                    <button class="dropdown-item" routerLink="user-admin/offline">
                        <i class="fa fa-fw fa-wifi me-2"></i> Manage Offline Data
                        @if (offlineQueue$ | async; as _offline) {
                            @if (_offline.length) {
                                <span class="badge-pill badge bg-success">{{ _offline.length }}</span>
                            }
                        }
                    </button>
                    <button class="dropdown-item warning" (click)="clearCaches()"><i class="fa fa-fw fa-trash me-2"></i> Clear Data Cache</button>
                    <div class="dropdown-divider"></div>
                    @if (!_user.account.impersonating) {
                        <button class="dropdown-item danger" (click)="userService.logOut()"><i class="fa fa-fw fa-arrow-right-from-bracket me-2"></i> Logout</button>
                    }
                    @if (_user.account.impersonating) {
                        <button class="dropdown-item danger" (click)="userService.exitImpersonation()">
                            <i class="fa fa-fw fa-arrow-right-from-bracket me-2"></i> Exit Impersonation
                        </button>
                    }
                    <div class="dropdown-divider"></div>
                    <div class="dropdown-item-text"><ngbd-darkmode-switch></ngbd-darkmode-switch></div>
                    <div class="dropdown-divider"></div>
                    <h6 class="dropdown-header">App Version: {{ version }}</h6>
                    <h6 class="dropdown-header">Environment: {{ env }}</h6>
                </div>
            </div>
        }
    }
</nav>
